<div class="box">
  <div class="box-header">
    <div class="pull-left">
      <form class="form-inline">
        <div class="form-group">
          <label class="control-label">No. of entries</label>
        </div>
        <div class="form-group">
          <select style="display: inline;" #selectElem class="form-control" [ngModelOptions]="{standalone: true}"
            [(ngModel)]="page.size" (change)="machines$.next({ offset: 0 })">
            @for (size of coreService.sizeOptions; track size) {
              <option [value]="size">{{size}}</option>
            }
          </select>
        </div>
      </form>
    </div>

    <div class="pull-right">
      <button class="btn btn-sm btn-info btn-flat pull-left margin" style="margin-top: 0px;"
        (click)="resetFilters()">Clear
      filters</button>
    </div>
  </div>
  <div class="box-body">

    <form [formGroup]="form">
      <ngx-datatable appTableScrollHorizontal [externalSorting]="false" [cssClasses]="iconsCss"
        [loadingIndicator]="isLoading" class="material striped" [rows]="rows" [columnMode]="'force'"
        [headerHeight]="'auto'" [rowHeight]="'50'" [footerHeight]="50" [externalPaging]="true"
        [count]="page.totalElements" [offset]="page.pageNumber" (page)='machines$.next($event)' (sort)="onSort($event)"
        [limit]="page.size">

        <ngx-datatable-column [sortable]="false" prop="index" name="{{'Sr No' | uppercase}}" [flexGrow]="1">
          <ng-template let-column="column" ngx-datatable-header-template>
            <p>{{column.name}}
            </p>
          </ng-template>

          <ng-template let-row="row" let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
            <strong>{{(page.size * page.pageNumber) + rowIndex + 1}}</strong>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="false" name="{{'Mac Address' | uppercase}}" prop="mac_address" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
            <p style="cursor: pointer;">{{column.name}}
              <!-- <i [class]="getIcon(column.prop)" aria-hidden="true"></i> -->
            </p>
            <!-- (click)="sort()" -->
            <input type="text" class="form-control input-sm" placeholder="Filter by {{column.name | titlecase}}"
              formControlName="{{column.prop}}">
          </ng-template>

          <ng-template let-row="row" ngx-datatable-cell-template>
            <p>{{row?.mac_address}}</p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column [sortable]="false" name="{{'Activated On' | uppercase}}" prop="activated_on" [flexGrow]="1">
          <!-- <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
          <p (click)="sort()" style="cursor: pointer;">{{column.name}}
            <i [class]="getIcon(column.prop)" aria-hidden="true"></i>
          </p>
        </ng-template> -->

        <ng-template let-row="row" ngx-datatable-cell-template>
          <p>{{row?.activated_on | date:'dd/MM/yyyy h:mm a'}}</p>
        </ng-template>
      </ngx-datatable-column>

      @if (group == groupTypes.ADMIN) {
        <ngx-datatable-column [sortable]="false" name="{{ 'Actions' | uppercase }}"
          [flexGrow]="1">
          <ng-template let-rowIndex="rowIndex" let-row="row" let-value="value" ngx-datatable-cell-template>
            @if (group == groupTypes.ADMIN && !row?.activated_on && !loading[(page.size * page.pageNumber) + rowIndex ]) {
              <a href="javascript:void(0);" title="Deactivated" (click)="activate(rowIndex,row?.id)">
                <i class="fa fa-toggle-off" aria-hidden="true"></i>
              </a>
            }
            @if (group == groupTypes.ADMIN && row?.activated_on && !loading[(page.size * page.pageNumber) + rowIndex]) {
              <a href="javascript:void(0);"  title="Activated" (click)="deActivate(rowIndex,row?.id)">
                <i class="fa fa-toggle-on" aria-hidden="true"></i>
              </a>
            }
            @if (loading[(page.size * page.pageNumber) + rowIndex]) {
              <mat-spinner diameter="15"></mat-spinner>
            }
          </ng-template>
        </ngx-datatable-column>
      }

    </ngx-datatable>
  </form>
</div>
</div>
